import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";

import "../styles/GallerySection.css";

const galleryImages = [
  { src: "Marrakesh Gallery Images/DSC06907.jpg", link: "/shop" },
  { src: "Marrakesh Gallery Images/DSC06918.jpg", link: "/shop" },
  { src: "Marrakesh Gallery Images/DSC06941.jpg", link: "/shop" },
  { src: "Marrakesh Gallery Images/DSC06946.jpg", link: "/shop" },
  { src: "Marrakesh Gallery Images/DSC07041.jpg", link: "/shop" },
  { src: "Marrakesh Gallery Images/DSC07072.jpg", link: "/shop" },
  { src: "Marrakesh Gallery Images/DSC07086.jpg", link: "/shop" },
  { src: "Marrakesh Gallery Images/DSC07272.jpg", link: "/shop" },
  // { src: "Marrakesh Gallery Images/DSC07286.jpg", link: "/shop" },
  // { src: "Marrakesh Gallery Images/DSC07306.jpg", link: "/shop" },
  // { src: "Marrakesh Gallery Images/DSC07402.jpg", link: "/shop" },
  // { src: "Marrakesh Gallery Images/DSC07410.jpg", link: "/shop" },
];

export default function GallerySection() {
  // Use media query to detect mobile devices
  const isMobile = window.matchMedia("(max-width: 768px)").matches;

  return (
    <div className="gallery-container">
      {isMobile ? (
        <Swiper
          slidesPerView={1.1} // one image per slide on mobile
          spaceBetween={5}
          className="gallery-swiper"
          centeredSlides={true}
        >
          {galleryImages.map((item, index) => (
            <SwiperSlide key={index}>
              <figure style={{ margin: 0 }}>
                <img src={item.src} alt={`Gallery image ${index + 1}`} />
                {/* <div>
                  <a href={item.link}></a>
                </div> */}
              </figure>
            </SwiperSlide>
          ))}
        </Swiper>
      ) : (
        <div className="gallery-grid">
          {galleryImages.map((item, index) => (
            <div className="gallery__item" key={index}>
              <figure style={{ margin: 0 }}>
                <img src={item.src} alt={`Gallery image ${index + 1}`} />
                <div>
                  <a href={item.link}></a>
                </div>
              </figure>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
